import { Stack } from '@mui/material';
import { z } from 'zod';

import { api } from 'common';

import { OrderJobParamsFormFields, OrderJobParamsSchema } from './Common/Orders';
import { PayorParamsFormFields, PayorParamsSchema } from './Common/Payor';
import { type AsynchronousJobVariant, RequiredStringSchema } from './common';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

import JobKind = api.RpaJob.Kind;

export const ExportNoticeOfAdmissionStatusVariant: AsynchronousJobVariant = {
  schema: z.object({
    jobKind: z.literal(JobKind.ExportNoticeOfAdmissionStatus),
    payload: OrderJobParamsSchema.merge(PayorParamsSchema).merge(
      z.object({
        noticeOfAdmissionNote: RequiredStringSchema,
      })
    ),
  }),
  Config: () => {
    return (
      <Stack spacing={2}>
        <OrderJobParamsFormFields />
        <PayorParamsFormFields />
        <BlockValueTemplateField
          fieldName="config.payload.noticeOfAdmissionNote"
          label="Notice of Admission Note"
          helperText="Enter the reference to the NOA Note. e.g. `{{noticeOfAdmission.note}}`"
          placeholder="e.g. {{noticeOfAdmission.note}}"
        />
      </Stack>
    );
  },
};
